import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../helpers/Records';
import { construct, fields } from '../../../helpers/LinkMapper';

const fieldSchema = {
    cost: [ fields.number ],
    count: [ fields.number ],
    fareType: [ fields.string ],
    discounted: [ fields.boolean ]
};

class Cost extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(Cost, json, getResolvers(fieldSchema));
    }
}

export default Cost;
